<div class="case-request-status-details">
  <div class="case-request-status-section">
    <div
      class="vo-heading-bold-16 mb-15"
      [innerHtml]="referenceDataLabels.OverviewIllustrationSelectedProductSubtitle | localizeLabel"
    ></div>
    <div class="vo-body-regular-14">
      {{ caseRequest.ProductDescription }}
    </div>
  </div>
  <div class="case-request-status-section">
    <div class="vo-heading-bold-16 mb-15" [innerHTML]="referenceDataLabels.CustomerOffer | localizeLabel"></div>

    <div class="mb-20" *ngIf="inProgressStatusesList.includes(caseRequest.CurrentStatusCode)">
      <div class="d-flex mb-10">
        <div class="d-inline-block case-request-status-in-progress__loader"></div>
        <div class="vo-body-bold-14" [innerHtml]="referenceDataLabels.OfferPendingTitle | localizeLabel"></div>
      </div>
      <div
        class="vo-body-regular-14 ml-35"
        [innerHtml]="referenceDataLabels.OfferPendingDescription | localizeLabel"
      ></div>
    </div>

    <ng-container *ngIf="readyStatusesList.includes(caseRequest.CurrentStatusCode)">
      <div class="d-flex mb-10">
        <span class="vo-icon case-request-status-icon case-request-status__ready-icon mr-15"></span>
        <span class="vo-body-bold-14" [innerHtml]="referenceDataLabels.OfferReadyTitle | localizeLabel"></span>
      </div>
      <div class="ml-35">
        <div
          *ngIf="caseRequest?.CurrentStatusCode == referenceDataSwitchCaseStatus.SwitchOfferIssuedOnline"
          class="mb-15 vo-body-regular-14"
          [innerHtml]="referenceDataLabels.OfferReadyOnlineDescription | localizeLabel"
        ></div>
        <div
          *ngIf="
            caseRequest?.CurrentStatusCode == referenceDataSwitchCaseStatus.SwitchOfferIssuedPostal ||
            caseRequest?.CurrentStatusCode == referenceDataSwitchCaseStatus.SwitchOfferIssuedForcedPostal
          "
          class="mb-15 vo-body-regular-14"
          [innerHtml]="referenceDataLabels.OfferReadyByPostDescription | localizeLabel"
        ></div>
        <div
          class="d-flex mb-15"
          [routerLink]="['/', interfaceTypeCode, 'caseOverview', caseIdAsHash, 'caseDocuments']"
          [queryParams]="{ DocumentId: caseRequest.DistributedCaseDocumentIDAsHash }"
        >
          <span class="vo-icon case-request-status-icon vo-icon-document mr-5"></span>
          <span
            class="vo-link fs-14"
            [innerHtml]="referenceDataLabels.OfferReadyCaseDocumentsLabel | localizeLabel"
          ></span>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="notProceedingStatusesList.includes(caseRequest.CurrentStatusCode)">
      <div class="d-flex mb-10">
        <span class="vo-icon case-request-status-icon case-request-status__error-icon mr-15"></span>
        <span class="vo-body-bold-14" [innerHtml]="referenceDataLabels.OfferNotProceedingTitle | localizeLabel"></span>
      </div>
      <div
        class="vo-body-regular-14 ml-35 mb-20"
        [innerHtml]="referenceDataLabels.OfferNotProceedingDescription | localizeLabel"
      ></div>
    </ng-container>

    <ng-container *ngIf="offerExpiredStatus == caseRequest.CurrentStatusCode">
      <div class="d-flex mb-10">
        <span class="vo-icon case-request-status-icon case-request-status__error-icon mr-15"></span>
        <span class="vo-body-bold-14" [innerHtml]="referenceDataLabels.OfferExpiredTitle | localizeLabel"></span>
      </div>
      <div
        class="vo-body-regular-14 ml-35 mb-20"
        [innerHtml]="referenceDataLabels.OfferExpiredDescription | localizeLabel"
      ></div>
    </ng-container>

    <ng-container *ngIf="caseRequest.CurrentStatusCode == referenceDataSwitchCaseStatus.SwitchOfferAccepted">
      <div class="d-flex mb-10">
        <span class="vo-icon case-request-status-icon case-request-status__ready-icon mr-15"></span>
        <span class="vo-body-bold-14" [innerHtml]="referenceDataLabels.OfferAcceptanceTitle | localizeLabel"></span>
      </div>
      <div
        class="vo-body-regular-14 ml-35 mb-20"
        [innerHtml]="referenceDataLabels.OfferAcceptanceDescription | localizeLabel"
      ></div>
    </ng-container>
  </div>
</div>
